import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'removeKebabCase',

})
export class RemoveKebabCasePipe implements PipeTransform {

    transform(value: string | null | undefined): string | null {
        if (value === null || typeof value === 'undefined' || typeof value !== 'string') {
            return null;
        }
        return value
            .split('-')
            .map(word => {
                if (word.length === 0) {
                    return '';
                }
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(' ');
    }

}
